import itemsServiceGen from "./generated/itemsServiceGen";
import { postCore as post } from "../../utils/httpInterceptor";

class itemsService extends itemsServiceGen {
  static async requestCreation(payload) {
    return await post("/api/legacy/invent-item-creation", payload);
  }
}

export default itemsService;
